import {Component, OnDestroy, Input, OnInit, AfterViewInit} from "@angular/core";
import { filter, some } from 'lodash';
import {Subscriber} from "rxjs";
import {UserService} from "@nrwl/common-lib";


@Component({
  selector: "wizard-users-sub-content",
  templateUrl: "./users.sub.content.html",
  styleUrls: ["../wizard.user.style.scss"],
  providers: []
})
export class UsersSubContentComponent implements OnInit, OnDestroy, AfterViewInit {

  @Input() step: any;
  @Input() subStep: any;
  @Input() wizardCtrl: any;
  addButtonDiable:boolean;
  memberGroups: any;
  filteredMemberGroups: any;// will contain only those items from memberGroups where hidden=false
  subscription: Subscriber<any>;

  constructor(private readonly userService: UserService) {
    this.memberGroups = [];
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }

  ngAfterViewInit() {
  }

  ngOnInit() {
    this.subStep._requestData();
    this.subscription = this.subStep.dataSourceObservable.subscribe(changes => {

      this.memberGroups = this.step.filterData(this.subStep.dataSource, this.step.output.userNames, 'userName');
      // this plays a role when subcontent page is reopened in the same wizard - we want to be sure users list
      // is filtered to follow search expression, stored in filterText field.
      this.filterUsersList(this.subStep.filterText);
    });
  }

  filterUsersList(newValue) {
    this.subStep.filterList(newValue);
    this.filteredMemberGroups = filter(this.memberGroups, (item: any) => !item.hidden);
  }

  flipValue(member) {
    member.isChecked = !member.isChecked;
    this.addButtonDiable = some(this.subStep.dataSource, {isChecked:true});
  }
}
